import { useContext } from 'react';
import { SettingsContext } from 'src/components/settings/SettingsContext';

// ----------------------------------------------------------------------

export const useSettings = () => useContext(SettingsContext);
